<script>
  export default {
    name: "ToggleDiv",
    data: () => ({
      isShow1: true,
      isShow2: true,
      isShow3: true,
      isShow4: true,
      isShow5: true,
      isShow6: true,
      isShow7: true,
      isShow8: true,
      isShow20: true,
    }),

    props: {
      msg: String,
    },
  };
</script>

<template>
<h1>Audio</h1>
  <div align="center" class="card-wrapper">
    <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
      <h4 class="card-title">Schallwandler</h4>
      <div class="card-body">


        <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="true">
            <h4 class="card-title">Mikrofone</h4>
            <div class="card-body" align="left">
                Mikrofone wandeln akustische Schallgrößen (Druck, Schnelle) in elektrische Größen ( Spannung, Strom). Dabei gibt es unterschiedliche <b>Wandlerprinzipien</b>:
                <br>
                <br>
                <ul>
                    <li> <b>Dynamische Mikrofone</b> (elektrodynamisches Prinzip, Induktion)</li>
                    <li> <b>Kondensatormikrofone</b> (elektrostatisches Prinzip)</li>
                    <li> <b>Elektret-Kondensatormikrofone</b> </li>
                    <li> <b>Kohlemikrofone</b> </li>
                    <li> <b>Piezomikrofone</b> </li>
                </ul>
                <br>
                <br>
                Die bekanntesten Wandlerprinzipien sind das elektrodynamische Prinzip, sowie das elektrostatische Prinzip. 
                Im folgenden werden auf die ersten beiden genannten Wandlerprinzipien näher eingegangen:
                <br>
                <br>
                <button class="btn btn-secondary m-3" style="width: 100%" @click="isShow1 = !isShow1" v-if="isShow1">Weiter</button>



                <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="!isShow1">
                    <h4 class="card-title" align="center">Elektrodynamische Mikrofone</h4>
                    <div class="card-body" align="left">
                        Elektrodynamische Mikrofone werden auch Tauchspulenmikrofone genannt. <br>
                        Sie erzeugen ein elektrische Signal durch Induktion.

                        <div align ="center" class="p-3">
                            <img src="@/assets/dynMic.png" alt="Dynamische Mikrofon" width="500">
                        </div>

                        Hauptbestandteil eines Tauchspulenmikrofons sind eine Membran und die Schwingspule, welche sich in einem magnetischen Feld des Permanentmagneten befindet.
                        Die Membran ist mit der Spule verbunden. Damit die Spule sich frei in dem Luftspalt 
                        bewegen und ein Gegenstoßen an die Wände des Permanentmagneten 
                        verhindert werden kann, wird sie durch eine Zentrierspinne zentriert. 
                        Sobald Schallwellen auf die Membran treffen, bewegt sich die Spule proportional 
                        zur Frequenz der auftretenden Schallschnelle. Dabei verändert sich die Leiterlänge der Spule im Magnetfeld. Durch die Veränderung der Leiterlänge der Spule im Magnetfeld, verändert sich der magnetische Fluss, was in einer induzierten Spannung, proportional zum ankommenden Schall resultiert. Dieses Signal kann dann aufgenommen und weiterverarbeitet werden.
                        <br>
                        <br>
                        <button class="btn btn-secondary" style="width: 100%" @click="isShow2 = !isShow2" v-if="isShow2">Weiter</button>


                    </div>
                </div>

                <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="!isShow2">
                    <h4 class="card-title" align="center">Elektrostatische Mikrofone</h4>
                    <div class="card-body" align="left">
                        Elektrostatische Mikrofone werden auch als Kondensatormikrofone bezeichnet. <br>
                        Sie erzeugen ein elektrisches Signal durch die Veränderung des Plattenabstands eines Kondensators.

                        <div align ="center" class="p-3">
                            <img src="@/assets/statMic.png" alt="Kondensatormikrofon" width="500">
                        </div>

                        Das Kondensatormikrofon basiert auf dem Prinzip, dass sich die Spannung über einen geladenen Kondensators mit dem Plattenabstand verändert.
                        Es befinden sich zwei leitende Platten, zwischen den eine Polarisationsspannung
                        herrscht - Zum einen ist sie durch die Membran gegeben ist und zum anderen durch
                        die Gegenelektrode. Der Kondensator wird mit einer Spannung versorgt (‘Spannungsversorgung’). Der Spannungsabfall wird anschließend an einen hochohmigen Widerstand gemessen, welcher parallel zum Kondensator geschaltet ist. Das gemessene abgefallene Signal bildet das Ausgangssignal des Mikrofons.
                    </div>
                    <button class="btn btn-secondary" style="width: 100%" @click="isShow3 = !isShow3" v-if="isShow3">Weiter</button>

                </div>


            </div>
        </div>

        <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="!isShow3">
            <h4 class="card-title">Lautsprecher</h4>
            <div class="card-body" align="left">
                Im Gegensatz zu Mikrofone wandeln Lautsprecher elektrische Größen (Spannung, Strom) in akustische Schallgrößen (Druck, Schnelle). <br>
                Auch im Bereich der Lautsprecher gibt es im Prinzip wie bei Mikrofonen, Wandlerprinzipien:
                <br>
                <br>
                <ul>
                    <li> <b>Dynamische Lautsprecher</b> (elektrodynamisches Prinzip)</li>
                    <li> <b>Magnetostatische Lautsprecher</b></li>
                    <li> <b>Elektrostatische Lautsprecher</b></li>
                    <li> <b>Piezolautsprecher</b></li>
                </ul>
                <br>
                <br>
                Zwei Wandlerprinzipien werden hier nochmal näher erläutert:
                <br>
                <br>
                <button class="btn btn-secondary" style="width: 100%" @click="isShow4 = !isShow4" v-if="isShow4">Weiter</button>


                <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="!isShow4">
                    <h4 class="card-title" align="center">Elektrodynamische Lautsprecher</h4>
                    <div class="card-body" align="left">

                        <div align ="center" class="p-3">
                            <img src="@/assets/dynLS.png" alt="Dynamische Mikrofon" width="400">
                        </div>

                        Der Tauchspulen-Lautsprecher beruht auf dem selben Prinzip wie das elektrodynamische Mikrofon, bei der eine Schwingspule an eine Membran befestigt ist. Die Spule wird in einem Luftspalt, im Magnetfeld eines Permanentmagneten bewegt.
                        Fließt ein Strom durch die Spule, wird die Membran durch die Lorentzkraft bewegt. Somit wird für die Bewegung der Lautsprechermembran gesorgt.
                        Die Stärke der Auslenkung der Schwingspule wird von der magnetischen Induktion, dem Stromfluss, der Leiterlänge unde dem Magnetfed beeinflusst.



                    </div>
                    <button class="btn btn-secondary" style="width: 100%" @click="isShow5 = !isShow5" v-if="isShow5">Weiter</button>

                </div>

                <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="!isShow5">
                    <h4 class="card-title" align="center">Elektrostatische Lautsprecher</h4>
                    <div class="card-body" align="left">


                        <div align ="center" class="p-3">
                            <img src="@/assets/statLS.png" alt="Kondensatormikrofon" width="400">
                        </div>

                        Ähnlich wie beim Kondensatormikrofon basiert der elektrostatische Lautsprecher auch auf der Funktionsweise eines Kondensators.
                        Zwei Platten werden durch ein Diaphragma getrennt.  Zwei Elektroden mit gleicher Ladung stoßen sich ab und zwei mit ungleicher Ladung an. Diese werden mit einer Spannung versorgt und sind maßgebend für die Auslenkung der Elektroden. Mittels der elektrostatischen Anziehungskraft wird mithilfe der angelegten Spannung Schallwellen erzeugt. 



                    </div>
                    <button class="btn btn-secondary"  @click="isShow20 = !isShow20" v-if="isShow20">Weiter</button>

                </div>


            </div>
        </div>


      </div>
    </div>

    <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="!isShow20">
        <h4 class="card-title" align="center">Dynamik</h4>
        <div class="card-body" align="left">
            Wenn man von den Analogen zu den digitalen Signalen geht, müssen Bezugsgrößen festgelegt werden. Diese sind je nach Audiosignal unterschiedlich eingestellt.
            Zur Normierung auf einen logarithmischen Bezugspegel, wird ein Effektivwert  genutzt. <br>
            <br>
            <h5>Effektivwert (Root Mean Square )</h5> 
            Um den Effektivwert nutzen zu können, ist es wichtig zu wissen, mit welchen analogen Größen gearbeitet wird.
            Im analogen Bereich haben beispielsweise Verstärker einen analogen Eingang. Da wird ein bestimmter Bereich an Spannung angenommen, wo sich das Ausgangssignal des Mikrofons befindet. Normiert wird dann auf eine Leistung oder Spannung.
            <br>
            <br>
            <div align="center">
                <img src="@/assets/RMS.png" alt="Effektivwert eines Signals" width="40%">
            </div>
            <br>
            <br>
            Analog:  0 dB entspricht:
            <ul>
                <li><b>Leistung </b>von 1 mW an einem Widerstand von 600 Ohm  (dBm)</li>
                <li><b>Spannung </b>von 0,775 V an einem Widerstand von 600 Ohm (dBu)</li>
            </ul>
            <br>
            <br>
            Somit kann auch für ein analoges Signal ein Pegel berechnet werden. <br>
            Um einen analogen Pegel in einen digitalen Pegel während der Quantisierung überführen zu können, muss nachgeschaut werden wie der Quantisierer ausgesteuert ist. Relevant sind die darin maximalen und minimalen Signalanteile im Signal. Der Maximalpegel stellt den höchst darstellbaren Zahlenwert dar (Übersteuerungsgrenze).
            <br>
            <br>
            Für den Arbeitspegel (0 dB) wird in vielen Audioproduktionen beispielsweise 6dB - 15dB darunter gewählt. 
            <br>
            <br>
            <div align="center">
                <img src="@/assets/Dynamikumfang.png" alt="Dynamikumfang" width="70%">
            </div>
            <br>
            <br>
            Die Abbildung zeigt, weshalb elektronische Geräte zur Verarbeitung von Audiosignalen in einem begrenzten Pegelbereich konzipiert sind.
            Der Headroom trennt den Bereich zwischen dem Bezugspegel (auch 'Nennpegel') und dem 'Maximalpegel', den ein Audiogerät verarbeiten kann.
            <br>
            <br>
            Alle Signalwerte, die den Maximalen darstellenden Bereich überschreiten, gelangen in den Aussteuerungsbereich <b>(= Clipping)</b>.
            Der Footroom bildet das untere Ende des Aussteuerungsbereich und bildet die Begrenzung, um das Rauschen nicht hörbar werden zu lassen. Kommt es zu niedrigen Signalwerten, entsteht eine Untersteuerung <b>(= schlechte SNR)</b>.
            Signale, die sich im Bereich zwischen dem Foot- und Headroom bewegen, liegen im Dynamikbereich. In diesem Bereich wird die Gefahr von Verzerrungen minimiert, und das Grundrauschen überspielt - ein optimaler Sound ist zu erwarten. 
            <br>
            <br>

        </div>
        <button class="btn btn-secondary"  @click="isShow6 = !isShow6" v-if="isShow6">Weiter</button>
    </div>

    <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="!isShow6">
        <h4 class="card-title" align="center">Audiokodierung</h4>
        <div class="card-body" align="left">
            Die einfachste Form um ein quantisiertes Signal zu erhalten, ist die <b>Pulse-Code-Modulation (PCM) </b>. Die Darstellung der quantisierten Abtastwerten erfolgt als Binärzahlen in einem festen Zeitraster.
            <br>
            <div align="center" class="m-3">
                <img src="@/assets/DPCM.png" alt="PCM" width="80%">
            </div>
            <br>
            <br>



            Ein Beispiel hierfür wäre die Dateikodierung auf einer Audio-CD:
            <br>
            <br>
            <ul>
                <li>44.100 Hz Abtastrate</li>
                <li>16 bit pro quantisiertem Abtastwert (65.536 Wertstufen)</li>
                <li>2 Kanäle (Stereo)</li>
                <li>--> 1.411.200 bit/s reine Nutzsignal-Datenrate</li>
            </ul>

            <br>
            <br>
            Typische Dateiformate hierbei wären dann:
            <br>
            <br>
            <ul>
                <li>.pcm (Rohdaten ohne Header -> Angabe über abgetasteter Frequenz nicht möglich)</li>
                <li>.wav (Ressource Interchange File Format - mit Header)</li>
                <li>.aiff (Mac)</li>
                <li>.au (Unix)</li>


            </ul>
            <button class="btn btn-secondary" style="width: 100%" @click="isShow7 = !isShow7" v-if="isShow7">Weiter</button>


            <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="!isShow7">
                <h4 class="card-title" align="center">Audio- Datenkompression</h4>
                <div class="card-body" align="left">
                    Große Datenmengen, beanspruchen einen hohen Speicherbedarf und längere Datenübertragungszeiten. Hierfür dient die Datenreduktion zur Kapazitätsoptimierung. Dabei werden redundante und irrelevante Daten eines Datenstroms erfasst und nicht übertragen.
                    Dabei wird zwischen Verlustfreien und Verlustbehafteten unterschieden:

                    <br>
                    <br>
                    <b>Verlustfreie</b> Datenreduktion: <br><br>
                    <ul>
                        <li>Abhängigkeit unterschiedlicher Signalkanäle untereinander (Kanalkoppelung) </li>
                        <li>Korrelation innerhalb eines Kanalsignals (Dekorrelation) </li>
                        <li>Unterschiedliche Auftrittswahrscheinlichkeiten von Signalwerten </li>
                    </ul>
                    <br><br>
                    <b>Verlustbehaftete</b> Datenreduktion: <br><br>
                    <ul>
                        <li>Weglassen perzeptiv nicht relevanter Signalanteile</li>
                        <li>Durch Maskierung sind bestimmte Signalbestandteile nicht wahrnehmbar und können deswegen asugelassen werden.</li>
                    </ul>


                    

                </div>
                <button class="btn btn-primary"  @click="isShow8 = !isShow8" v-if="isShow8">Modul abschließen</button>

            </div>

        </div>
    </div>

  </div> 
  
</template>

<style>
.btn {
    background-color: #528382
}
</style>